import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Card, CardBody } from '@components/ui';
import { LoginForm } from './LoginForm';
import { Logo } from '@components/common/Logo';

export function LoginPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [showExpired, setShowExpired] = useState(false);

  useEffect(() => {
    if (searchParams.get('expired') === '1') {
      setShowExpired(true);
      // Remove the query param from URL without reload
      searchParams.delete('expired');
      setSearchParams(searchParams, { replace: true });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary-100 dark:bg-secondary-900 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <Logo height={80} />
          </div>
          <p className="text-secondary-600 dark:text-secondary-400">
            Portal de Facturación Electrónica
          </p>
        </div>

        {showExpired && (
          <div className="mb-4 rounded-md bg-yellow-50 border border-yellow-200 p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6zm0 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm text-yellow-700">
                  Tu sesión ha expirado. Por favor, inicia sesión nuevamente.
                </p>
              </div>
            </div>
          </div>
        )}

        <Card>
          <CardBody className="p-8">
            <h2 className="text-2xl font-bold text-secondary-900 dark:text-white mb-6">
              Iniciar Sesión
            </h2>
            <LoginForm />
          </CardBody>
        </Card>

        <p className="text-center text-sm text-secondary-600 dark:text-secondary-400 mt-6">
          © {new Date().getFullYear()} Factura Libre. Todos los derechos reservados.
        </p>

        {/* Versión del portal — para verificar qué build está publicado. Sale de
            package.json; el tooltip muestra la fecha de compilación. */}
        <p
          title={`Compilado: ${new Date(__BUILD_TIME__).toLocaleString('es-PA')}`}
          className="mt-1 select-none text-center text-xs text-secondary-400 dark:text-secondary-600"
        >
          v{__APP_VERSION__}
        </p>
      </div>
    </div>
  );
}
